import React, { useState } from "react";
import { Table, Button, Tag, Checkbox } from "antd";
import { FaTrash } from 'react-icons/fa';
const UserList = ({ users, onSelectUser, selectedUser }) => {
  const columns = [
    {
      dataIndex: "details",
      render: (_, record) => (
        <Checkbox
        checked={selectedUser?.id === record.id} // So sánh với user đang được chọn
        onChange={(e) => onSelectUser(record, e.target.checked)}
      />
    ),
      key: "details",
    },
    {
      title: "Tên đăng nhập",
      dataIndex: "username",
      key: "username",
    },
    // {
    //   title: "ID",
    //   dataIndex: "id",
    //   key: "id",
    // },
    {
      title: "Tên người dùng",
      dataIndex: "full_name",
      key: "full_name",
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },
    {
      title: "Tài khoản",
      dataIndex: "type_name",
      key: "type_name",
    },
    // {
    //   dataIndex: "delete",
    //   key: "delete",
    //   render: (text, record) => (
    //     <div onClick={()=>console.log(record.id)}>
    //       <FaTrash color="red"/>
    //     </div>
    //   ),
    // },
  ];

  return <Table  dataSource={users} columns={columns} rowKey="username" />;
};

export default UserList;